<template>
  <!-- 检测领域 -->
  <div class="detection" ref="detection" style="width: 100%">
    <!-- 页面头部 -->
    <pageHeader ref="pageHeader" pageStatus="2" />

    <!-- 一级导航 -->
    <section class="first-nav">
      <van-tabs v-model="firstNavData.current" @change="changeFirstNav">
        <van-tab v-for="item in firstNavData.list" :key="item.id" :title="item.name"></van-tab>
      </van-tabs>
    </section>

    <!-- 介绍 & 二级导航 -->
    <section class="info-two-nav">
      <section class="info-box">
        <div class="info-name">{{solutionData.name}}</div>
        <!--   -->
        <div class="info-desc" :class="{'m-h': solutionData.typeDesc.length > 79 && !viewMoreDesc}" v-if="solutionData.typeDesc" ref="infoDesc">
          {{solutionData.typeDesc.length > 76 && !viewMoreDesc ? solutionData.typeDesc.slice(0,70) : solutionData.typeDesc}}
          <span class="open-desc" v-if="!viewMoreDesc && solutionData.typeDesc.length > 76" @click="viewMoreDesc = true">展开</span>
        </div>
      </section>
      <section class="two-nav">
        <div class="two-nav-row" v-for="(item, idx) in twoNavList.list" :key="idx">
          <div class="two-nav-item" :class="{'two-nav-item-active': twoNavList.current == citem.id}" v-for="citem in item" :key="citem.id" @click="changeTwoNav(citem)">{{citem.name}}</div>
        </div>
      </section>
    </section>

    <!-- 产品区域 -->
    <section class="product-box">
      <div v-if="productList.length">
        <div class="product-row" v-for="(item ,idx) in productList" :key="idx">
          <div class="product-item" v-for="citem in item" :key="citem.id" @click="toProductDetail(citem)">
            <div class="product-img">
              <img :src="$path + citem.image" alt="">
            </div>
            <div class="product-hot" v-if="citem.hots == 1">
              <img src="../../assets/detection/mb-hot.png" alt="">
            </div>
            <div class="product-name text-over">{{citem.name}}</div>
            <div class="product-desc text-over">样品：{{citem.sample}}</div>
            <div class="product-attr">
              <span class="text-over span-1" v-if="citem.testPeriod">{{citem.testPeriod}}</span>
              <span class="text-over span-2" v-if="citem.urgent == 1">可加急</span>
            </div>
          </div>
        </div>
      </div>
      <div class="empty-box" v-else>
        <img class="empty-img" src="../../assets/kong.png" alt="">
        <div class="empty-text">当前数据为空</div>
      </div>
    </section>
    
    <!-- 分页 -->
    <section class="mb-detection-pagenation" v-if="page.total > page.size && productList.length">
      <pagination :pageindex="page.page" :rows="page.size" @handle-changepage="changepage" :total="page.total"></pagination>
    </section>

    <section class="vadio-area" v-if="curNavArtcle">
      <div class="vidio-box">
        <div class="vidio-bg" v-if="!showVadioDialog" @click="showVadioDialog=true">
          <el-image
            style="width: 6.9rem; height: 4.18rem"
            fit="cover"
            :src="$path + videoDetail.art.imageUrl"
          />
          <img class="play-btn" src="../../assets/detection/vadio-play.png" alt="" />
        </div>
        <video v-if="showVadioDialog" width="100%" height="100%" controls autoplay>
          <source :src="$path + videoDetail.vedio.url" type="video/mp4">
        </video>
      </div>
      <div class="art-box">
        <div class="art-name">{{videoDetail.art.title}}</div>
        <div class="art-view" @click="jumpArtDetail">查看详情 ></div>
      </div>
      <div class="art-desc">{{videoDetail.art.description}}</div>
    </section>
  </div>
</template>

<script>
  // 设置rem
  document.documentElement.style.fontSize =
  document.documentElement.clientWidth / 7.5 + 'px';


  (function() {
    
    // 22222222
    // if (document.documentElement.clientWidth > 960) {
        // var hm = document.createElement("script");
        // hm.src = "https://hm.baidu.com/hm.js?7c776de221151da059e4b4bd67d03cbb";
        // var s = document.getElementsByTagName("script")[0]; 
        // s.parentNode.insertBefore(hm, s);
    // }
    var _hmt = _hmt || [];
    var hm_tongji = document.createElement("script");
    hm_tongji.src = "https://hm.baidu.com/hm.js?3e2d2850e3bcb3c24de01f284a5849ad";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm_tongji, s);
  })();
import { segmentationCharacter } from "@/js/validate.js";
export default {
  components: {
    pageHeader: () => import("@/components/header"),
    pagination: () => import("@/components/pagination")
  },
  computed: {
  },
  data() {
    return {
      id:'',
      twoLeve:'',
      showVadioDialog: false, // 视频展示
      firstNavData: {current: 0, list: [] }, // 一级导航菜单
      twoNavList: {current: 0, list: [] }, // 二级导航菜单
      solutionData: {}, // 行业解决方案数据
      segmentationCharacter,
      searchKey: '', // 搜索关键词
      productList: [], // 产品列表
      page: {
        page: 1,
        size: 10,
        total: 1
      },
      playerOptions : {
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          src: 'https://www.w3school.com.cn/i/movie.mp4',  // 路径
          type: 'video/mp4'  // 类型
        }],
        poster: "http://test.xaunqd.com/file/2021/05/17/b9539bde323879bf483d0a23474fb8ed.png", //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true  //全屏按钮
        }
      },
      curNavArtcle: false, // 底部文章数据是否存在
      videoDetail: {}, // 底部视频相关
      viewMoreDesc: false // 查看一级菜单描述
    }
  },
  watch:{
    $route(){

      this.id = this.$route.query.id
      if (this.$route.query.twoLeve){
        this.twoLeve = this.$route.query.twoLeve
      }
      this.searchKey = this.$route.query.search
      this.getNavList()
      this.getVideo()
    }
  },
  created() {
    this.id = this.$route.query.id
    if (this.$route.query.twoLeve){
      this.twoLeve = this.$route.query.twoLeve
    }
    // this.getSolutionInfo()
  },
  beforeMount() {
    this.searchKey = this.$route.query.search
    // 改变高度
    document.querySelector('.container-style').setAttribute('style', '600px!important');
    this.getNavList();
    this.getVideo();
  },
  beforeDestroy() {
    // 恢复高度
    document.querySelector('.container-style').setAttribute('style', '900px!important');
  },
  mounted() {
    const obj = {
      platformType : 1,
      targetPage : window.location.href
    }
    this.$api.iotHome.loggingData(obj)
    .then((res) => {
        if (res.data.success == true) {
        console.log('数据记录成功');
      }
    })
    
    var svgs = document.querySelectorAll('img[src$=".svg"]')

    svgs.forEach(item => {
      inject(item, function(err, svg) {
        if (err) throw err
      })
    })
  
 
  },
  methods: {
    getVideo() {
      this.$api.iotHome.videoApi({id: this.firstNavData.list[this.firstNavData.current].id}).then(res => {
        if(res.data.success) {
          if(res.data.data.length) {
            this.videoDetail = {
              vedio: res.data.data[1],
              art: res.data.data[0]
            };
            // 有数据
            this.curNavArtcle = true;
          } else {
            // 无数据
            this.curNavArtcle = false;
          }
        }
      })
    },
    // 获取所有解决方案
    getNavList() {
      if(window.localStorage.getItem("detaList")) {
        this.rangeNavData(JSON.parse(window.localStorage.getItem("detaList")))
          
        this.getProductList();
        return
      }
       this.$api.iotHome
        .typelist()
        .then((res) => {
          if (res.data.success) {
            window.localStorage.setItem("detaList", JSON.stringify(res.data.data));
            this.rangeNavData(res.data.data)
            this.getProductList();
          }
        });
    },
    rangeNavData(list){
      
      this.firstNavData.current = list.findIndex(item => item.id === this.id)
      this.firstNavData.list = list
      this.solutionData = list[this.firstNavData.current]
      let arr = [];
      (this.solutionData.children || []).forEach((item, idx) => {
        if(idx % 3 === 0) {
          arr[arr.length] = []
        } 
        arr[arr.length - 1].push(item)
      })
      
      this.countInfoDesc()
      this.twoNavList.list = arr;
      this.twoNavList.current = this.twoLeve || this.twoNavList.list[0][0].id
    },
    // 获取解决方案信息
    // getSolutionInfo() {
    //   this.$api.iotHome
    //     .productClassifyDetail({
    //       parentId: this.id
    //     })
    //     .then((res) => {
    //       if(res.data.success) {
    //         this.solutionData = res.data.data
    //       }
    //     });
    // },
    
    // 获取二级类别下产品列表
    getProductList(changeScroll = false) {
      const listdata = {
        rows: this.page.size,
        page: this.page.page,
        type: this.twoNavList.current,
        siteId: 0
      }
      this.$api.iotHome.list(listdata).then((res) => {
        if (res.data.success == true) {
          const arr = []
          
          res.data.data.forEach((item, idx) => {
            if(idx % 2 === 0) {
              arr[arr.length] = []
            } 
            arr[arr.length - 1].push(item)
          })
          this.productList = arr
          this.page.total = parseInt(res.data.code)
          
          changeScroll && (document.documentElement.scrollTop = 388)
        }
      });
    },
    // 改变页面url 
    changeUrl(type) {
      const route = this.$route
      let path = route.path
      let query = {
        id: this.solutionData.id,
        name: this.solutionData.name,
        twoLeve: this.twoNavList.current,
      };
      this.$router.push({path, query}) 

    },
    // 跳转详情
    toProductDetail(data) {
      const { href } = this.$router.resolve({
          path: "/detectionDetail",
          query: {
            id: data.id
          }
      })
      window.open(href, '_blank')
    },
    toindex(data){
      this.$router.push({
        path: "/",
        query: {
          type: data ? data : ''
        }
      });
    },
    // 切换一级导航
    changeFirstNav() {
      const select = this.firstNavData.list[this.firstNavData.current];
      console.log('select::: ', this.firstNavData.current, select, select.children);
      this.solutionData = select;
      const arr = [];
      select.children.forEach((item, idx) => {
        if(idx % 3 === 0) {
          arr[arr.length] = []
        } 
        arr[arr.length - 1].push(item)
      })
      this.showVadioDialog = false; // 视频初始化
      this.twoNavList.list = arr;
      this.twoNavList.current = select.children[0].id
      this.viewMoreDesc = false // 描述展开全部初始化
      
      this.page.page = 1
      // this.countInfoDesc()
      // this.getProductList()
      // this.getVideo()
      this.changeUrl(1)
    },
    // 切换二级导航
    changeTwoNav(item) {
      const id = item.id;
      this.twoNavList.current = id;
      this.page.page = 1
      // this.getProductList()
      this.changeUrl(2)
    },
    // 展开一级菜单描述
    countInfoDesc() {
      // this.$refs.infoDesc
      // debugger
    },
    show53() {
      const specs="height=600,width=1000,alwaysRaised,directories=no,toolbar=no,titlebar=no,menubar=no,scrollbars=no,left=300,top = 200, resizable=no,location=no, status=no"
      window.open("https://ada.baidu.com/site/wjzzrg3w/agent?imid=d55b08de4f857a0038a33d33ef9afaf7","_blank",specs)
    },
    // 跳转文章
    jumpArtDetail() {
      const routeUrl = this.$router.resolve({
        path: '/enterpriseDetail',
        query: {id: this.videoDetail.art.articleId},
      });
      window.open(routeUrl.href);
    },
    // 切换分页
    changepage(val) {
      console.log(val)
      this.page.page = val
      this.getProductList(true)
      this.changeUrl()
    },
    // 搜索
    searchChange() {
      if(!this.searchKey) {
        this.$message({
          message: '请输入要搜索的关键字~',
          type: 'warning',
        });
        return
      };
      const route = this.$route
      // 页面来源搜索
      if(this.$route.query.search) {
        this.getProductList()
        return
      }
      // 页面来源二级页面
      let path = route.path
      let query = {
        id: this.solutionData.id,
        name: this.solutionData.name,
        search: this.searchKey
      }
      const routeUrl = this.$router.resolve({
        path,
        query,
      });
      window.open(routeUrl.href);

    }
    
  }
};
</script>

<style lang="scss" scoped>
.first-nav {
  height: 63px;
  background-color: #fff;
  position: relative;
  padding-top: 9px;
}

// 介绍 & 二级导航
.info-two-nav {
  padding: .71rem .3rem .3rem;
  background-color: #ECEFF6;
  .info-name {
    width: 100%;
    height: .48;
    font-size: .5rem;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #282B45;
    line-height: .48rem;
    margin-bottom: .4rem;
  }
  .info-desc {
    width: 100%;
    font-size: .26rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #282B45;
    line-height: .42rem;
    position: relative;
    &.m-h {    
      overflow: hidden;
      max-height: 1.26rem;
    }
  }
  .open-desc {
    position: absolute;
    // bottom: 0;
    // right: 0;
    font-size: .26rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #224CFF;
    line-height: .46rem;
    background: #ECEFF6;
    padding: 0 .15rem;
    margin-top: -1px;
  }
  .info-box {
    margin-bottom: .5rem;
    position: relative;
  }
  .two-nav {
    width: 100%;
    font-size: .24rem;
    line-height: .25rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #282B45;
  }
  .two-nav-row {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    margin-bottom: .1rem;
  }
  .two-nav-item {
    width: 2.23rem;
    height: .8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border-radius: 10px;
    padding: 0 .28rem;
    text-align: center;
    margin-right: .1rem;
    &:last-child {
      margin-right: 0;
    }
  }
  .two-nav-item-active {
    background-color: #224CFF;
    color: #fff;
    font-weight: bold;
  }
}

// 产品区域
.product-box {
  width: 100%;
  padding: .5rem .3rem .4rem;
  background-color: #fff;
  .product-row {
    width: 100%;
    margin-bottom: .16rem;
    display: flex;
    justify-content: space-between;
  }
  .product-item {
    width: 3.38rem;
    height: 3.9rem;
    background-color: #fff;
    border-radius: .14rem;
    overflow: hidden;
    border: 1px solid #E1E2F5;
    position: relative;
    &:active {
      background: linear-gradient(0deg, #224CFF 0%, #4065FF 100%);
      * {
        color: #fff;
      }
      span {
        background: #4064FF;
      }
    }
  }
  .product-img {
    width: 100%;
    height: 2.03rem;
  }
  
  img {
    width: 100%;
    height: 100%; 
  }
  .product-hot {
    position: absolute;
    left: .2rem;
    top: 1.85rem;
    width: .58rem;
    height: .34rem;
  }
  .product-name {
    padding: 0 .2rem;
    margin-top: .23rem;
    height: .32rem;
    font-size: .3rem;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #282B45;
    line-height: .32rem;
  }
  .text-over {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .product-desc {
    margin-top: .14rem;
    height: .26rem;
    font-size: .24rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #A2A3B4;
    line-height: .2rem;
    padding: 0 .2rem;
    display: flex;
    align-items: center;
  }
  .product-attr {
    margin-top: .22rem;
    padding: 0 .2rem;
    white-space: nowrap;
    span {
      display: inline-block;
      line-height: .42rem;
      background: #F5F5F5;
      border-radius: .06rem;
      padding: 0 .11rem;
      font-size: .24rem;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #777995;
      margin-right: .12rem;
      &.span-1 {
        max-width: 1.9rem;
      }
      &.span-2 {
        margin-right: 0;
      }
    }
  }
}  


.empty-box {
  width: 100%;
  .empty-img {
    width: 4.88rem;
    height: 3.83rem;
    display: block;
    margin: 0 auto;
  }
  .empty-text {
    text-align: center;
    font-size: .3rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #A2A3B4;
  }
}

.vadio-area {
  padding: .54rem .3rem;
  background: #ECEFF6;
  .vidio-box {
    width: 6.9rem;
    height: 4.18rem;
    position: relative;
  }
  .vidio-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
  }
  .play-btn {
    width: .9rem;
    height: .9rem;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .art-box {
    margin-top: .2rem;
    min-height: .78rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #CDCFD8;
  }
  .art-name {
    font-size: .4rem;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #787A8D;
    width: 5rem;
  }
  .art-view {
    font-size: .3rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #395FFF;
  }
  .art-desc {
    margin-top: .4rem;
    font-size: .26rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #A2A3B4;
    line-height: .44rem;
  }

}

</style>

<style lang="scss">
.detection {
  .van-tab--active {
    font-weight: bold;
    color: #224CFF;
    font-size: 18px;
    font-family: Source Han Sans CN;
  }
  .van-tabs__line {
    background-color: #224CFF;
    width: 30px;
  }
  .mb-detection-pagenation {
    .pagination_container{
      .el-pagination {
        width: 100%;
        overflow-x:auto;
        text-align: center;
        padding: 0 0 .6rem 0 ;
      }
      .el-pager{
        li{
          color: #9698a0!important;
          border-radius: 2px;
          border: 1px solid #A2A3B4;
          background-color: transparent!important;
        }
        li.active{
          background: #395FFF!important;
          color: #fff!important;
        }
        li.active:hover{
          color: #fff!important;
        }
        li:hover{
          color: #9698a0!important;
        }
        li:active {
          border: 1px solid #A2A3B4;
        }
      }
    }
    .mpaginationContainer{
      .el-pagination {
        padding: 0 0 .6rem 0;
      }
      .btn-prev{
        min-width: .6rem!important;
        min-height: .6rem!important;
        border: 1px solid #A2A3B4;
        background-color: transparent!important;
      }
      .btn-next{
        min-width: .6rem!important;
        min-height: .6rem!important;
        border: 1px solid #A2A3B4;
        background-color: transparent!important;
      }
      .el-pager{
        .more::before{
          line-height: .6rem;
        }
        li{
          min-width: .6rem!important;
          min-height: .6rem!important;
          line-height: .59rem;
          font-size: .25rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          background-color: transparent!important;
        }
      }
    }
  }
}
</style>